const siteUrl = import.meta.env.VITE_SITE_URL || "https://reworkltd.com";

export function setSeo({ title, description, locale, path }) {
  const fullTitle = title ? `${title} | Rework Ltd` : "Rework Ltd";
  document.documentElement.lang = locale === "th" ? "th" : "en";
  document.title = fullTitle;

  setMeta("description", description || "Refine, reinvent, and rework digital operations with Rework Ltd.");
  setMeta("og:title", fullTitle, "property");
  setMeta("og:description", description || "", "property");
  setMeta("og:type", "website", "property");
  setLink("canonical", `${siteUrl}${path === "/home" ? "/" : path}`);
}

function setMeta(name, content, attr = "name") {
  let node = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!node) {
    node = document.createElement("meta");
    node.setAttribute(attr, name);
    document.head.appendChild(node);
  }
  node.setAttribute("content", content);
}

function setLink(rel, href) {
  let node = document.head.querySelector(`link[rel="${rel}"]`);
  if (!node) {
    node = document.createElement("link");
    node.setAttribute("rel", rel);
    document.head.appendChild(node);
  }
  node.setAttribute("href", href);
}
